import { render, staticRenderFns } from "./report_sales.vue?vue&type=template&id=b86e56f2"
import script from "./report_sales.vue?vue&type=script&lang=js"
export * from "./report_sales.vue?vue&type=script&lang=js"
import style0 from "./report_sales.vue?vue&type=style&index=0&id=b86e56f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports